<div class="container" *transloco="let t">
  <app-svg-icon class="logo" [path]="'/assets/logo.svg'"></app-svg-icon>
  <h2>{{ t('LOGIN-PAGE.TITLE') }}</h2>
  <p>{{ t('LOGIN-PAGE.SUBTITLE') }}</p>
  <app-input-text [label]="t('LOGIN-PAGE.INPUT.USERNAME')" [control]="userName"></app-input-text>
  <app-input-password [label]="t('LOGIN-PAGE.INPUT.PASSWORD')" [control]="password"></app-input-password>
  <p class="hint right"><span>{{ t('LOGIN-PAGE.FORGOT-PASSWORD') }}</span></p>
  <app-navigation-box
    [leftIsVisible]="false"
    [rightIsActive]="isActive()"
    [rightText]="t('LOGIN-PAGE.BUTTON')"
    (rightIsPressed)="login()"></app-navigation-box>
  <p class="hint">{{ t('LOGIN-PAGE.NO-ACCESS') }} <span>{{ t('LOGIN-PAGE.REQUEST-ACCESS') }}</span></p>
</div>
